import {
  AuditAlertContext,
  AuditAlertDigestContext
} from "../auditLog.types";

export const isDigestContext = (
  context?: AuditAlertContext | null
): context is AuditAlertDigestContext =>
  (context as AuditAlertDigestContext)?.kind === "digest";
